import { gray } from '../assets/js/colors'

export const OCStatus = {
  NaoAssociadas: {
    label: 'Não Associada',
    color: gray,
  },
  NaoExpedida: {
    label: 'Não Expedida',
    color: '#e7be74',
  },
  Expedida: {
    label: 'Expedida',
    color: '#57c278',
  },
  Cancelada: {
    label: 'Cancelada',
    color: '#df4747',
  },
}
export default function (status) {
  for (const key in OCStatus) {
    const s = OCStatus[key]
    if (s.label === status) return OCStatus[key]
  }
}
